import { Button, Modal } from 'antd';
import { map } from 'lodash';
import React, { useEffect } from 'react';
import { GA_EVENT, GA_LABEL } from '../common/constants';
import { Event } from '../common/trackEvents';

const AudioPlayerModal = ({ showModal, setShowModal, audios }) => {
  useEffect(() => {
    if (showModal) {
      Event(GA_EVENT.OPENED_AUDIO_MODAL, {
        label: GA_LABEL.OPENED_AUDIO_MODAL,
        // eslint-disable-next-line no-undef
        pathname: window?.location?.href
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      maskClosable={false}
      centered
      visible={showModal}
      className="import-modal"
      footer={null}
      closable={false}
      onCancel={() => setShowModal(false)}
      destroyOnClose
    >
      <h2 className="mb-25">Audio Player</h2>
      {map(audios, (audio, index) => (
        <div key={`audio-${index}`} className="d-flex align-center mt-25">
          <div className="d-flex align-center">
            <span>Audio</span>
            <span className="ml-5"> {index + 1}</span>
          </div>
          {/*  eslint-disable-next-line jsx-a11y/media-has-caption */}
          <audio
            controls
            name="media"
            className="audio-player ml-10"
            controlsList="nodownload noplaybackrate"
          >
            <source src={audio} type="audio/mp4" />
          </audio>
        </div>
      ))}
      <div className="form-buttons mt-25">
        <Button
          type="primary"
          shape="round"
          onClick={() => setShowModal(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default AudioPlayerModal;
